import UntitledIcon from '@payaca/untitled-icons';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, useMemo } from 'react';
import Button from '../../Button/Button';

export type TPaginationBarProps = {
  className?: string;
  pageSize: number;
  currentPage: number;
  totalItems: number;
  onPageChange: (page: number) => void;
};

export const PaginationBar: FC<TPaginationBarProps> = ({
  pageSize,
  currentPage,
  totalItems,
  onPageChange,
  className,
}) => {
  const minPage = 1;
  const maxPage = Math.ceil(totalItems / pageSize);

  const showing = useMemo(() => {
    if (totalItems === 0) return `Showing 0`;

    let top = pageSize * currentPage;

    if (currentPage === maxPage) {
      top = totalItems;
    }

    const bottom = (currentPage - 1) * pageSize + 1;

    return `Showing ${bottom === top ? bottom : `${bottom} - ${top}`}`;
  }, [currentPage, pageSize, totalItems, maxPage]);

  return (
    <div
      className={clstx(
        'typography:prose grid gap-3 md:flex md:items-center md:justify-between',
        className
      )}
    >
      <div>
        <p>
          {showing} of{' '}
          <span data-testid="total-number-of-results">{totalItems}</span>
        </p>
      </div>

      <div className="inline-flex gap-x-2">
        <Button
          variant={'white'}
          size={'sm'}
          colour={'black'}
          disabled={currentPage === minPage}
          onClick={() => {
            onPageChange(currentPage - 1);
          }}
        >
          <UntitledIcon name={'chevron-left'} className="h-4 w-4" /> Prev
        </Button>
        <Button
          variant={'white'}
          size={'sm'}
          colour={'black'}
          disabled={currentPage >= maxPage}
          onClick={() => {
            onPageChange(currentPage + 1);
          }}
        >
          Next <UntitledIcon name={'chevron-right'} className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
